import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ExportRequestService } from '../../../core/services/export-request.service';

/**
 * v1.6.872 — Asana 1214428404017115... (export-by-request).
 * Single app-wide modal. Mounted once in the root shell; shown whenever any
 * data-export button calls ExportRequestService.open(). Tells the operator
 * that exports are handled on request by support, with a one-tap mailto.
 */
@Component({
  selector: 'app-export-request-modal',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div *ngIf="svc.isOpen()"
         class="fixed inset-0 z-[60] flex items-center justify-center bg-black/40 p-4"
         (click)="svc.close()">
      <div class="bg-white rounded-xl shadow-2xl w-full max-w-md overflow-hidden"
           (click)="$event.stopPropagation()">
        <div class="p-5 border-b border-gray-100 flex items-start gap-3">
          <div class="w-10 h-10 rounded-full bg-indigo-100 text-indigo-600 flex items-center justify-center shrink-0">
            <i class="fa-solid fa-file-export"></i>
          </div>
          <div class="flex-1 min-w-0">
            <h3 class="text-base font-semibold text-gray-900">Export by request</h3>
            <p class="text-sm text-gray-500 mt-0.5">Exports are handled by our team.</p>
          </div>
          <button type="button" (click)="svc.close()"
                  class="text-gray-400 hover:text-gray-600 shrink-0" aria-label="Close">
            <i class="fa-solid fa-xmark"></i>
          </button>
        </div>

        <div class="px-5 py-4 space-y-3">
          <p class="text-sm text-gray-700">
            To request this export, email
            <a [href]="'mailto:' + svc.supportEmail"
               class="font-medium text-indigo-600 hover:text-indigo-700">{{ svc.supportEmail }}</a>
            and we'll send it over.
          </p>
        </div>

        <div class="px-5 py-4 border-t border-gray-100 flex items-center justify-end gap-2">
          <button type="button" (click)="svc.close()"
                  class="px-4 py-2 text-sm font-medium text-gray-600 hover:text-gray-800 rounded">
            Close
          </button>
          <a [href]="'mailto:' + svc.supportEmail" (click)="svc.close()"
             class="px-4 py-2 text-sm font-semibold text-white bg-indigo-600 hover:bg-indigo-700 rounded inline-flex items-center gap-2">
            <i class="fa-solid fa-envelope"></i>
            Email support
          </a>
        </div>
      </div>
    </div>
  `,
})
export class ExportRequestModalComponent {
  readonly svc = inject(ExportRequestService);
}
